import { render, staticRenderFns } from "./LTableBody.vue?vue&type=template&id=99451446&scoped=true"
import script from "./LTableBody.vue?vue&type=script&lang=js"
export * from "./LTableBody.vue?vue&type=script&lang=js"
import style0 from "./LTableBody.vue?vue&type=style&index=0&id=99451446&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99451446",
  null
  
)

export default component.exports